import { call, put, takeEvery } from "redux-saga/effects";

import { TOGGLE_BLOCK_USER, ToggleBlockUserAction } from "./actionTypes";
import { toggleBlockUserError, toggleBlockUserSuccess } from "./actions";
import { toggleBlockUser } from "../../../helpers/backend_helper";

function* toggleBlockUserSaga({
  payload: { id, state, history },
}: ToggleBlockUserAction) {
  try {
    yield call(toggleBlockUser, id, state);
    yield put(toggleBlockUserSuccess());
  } catch (error) {
    yield put(toggleBlockUserError(error));
  }
}

function* TeacherAdminSaga() {
  yield takeEvery(TOGGLE_BLOCK_USER, toggleBlockUserSaga);
}

export default TeacherAdminSaga;
